import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_VISTAS = 'ALL_VISTAS';
export const LOADING_ALL_VISTAS = 'LOADING_ALL_VISTAS';
export const ACTIVO_VISTAS = 'ACTIVO_VISTAS';
export const PARAMS_VISTAS = 'PARAMS_VISTAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const vistasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_VISTAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_VISTAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_VISTAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_VISTAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
